export default __webpack_public_path__ + "static/media/bu1.fa188590.jpg";